module.exports = __webpack_public_path__ + "static/media/cook_food.f746530b.svg";